import type { MaybeBoolean } from '../../utils/types/maybe';
import type { NullableString } from '../../utils/types/nullable';

export type BaseFetchProps = {
  loading: boolean;
  success: MaybeBoolean;
  error: NullableString;
};

export const defaultBaseFetchProps: BaseFetchProps = {
  loading: false,
  success: undefined,
  error: null,
};
